import request from "../../../../../helper/request";

const api = {
  updatePassword: (data) => {
    return request.patch(`/admin/users/change-password`, data);
  }
};

export default api;
